/**
 * Resolve the study selected by an entry URL before React routing begins.
 * An explicit task has highest priority. Any organization recruitment link is
 * the main email/device study and must override stale isolated-task storage.
 */
export function resolveEntryTask(
  search: string,
  storedTask: string | null
): string | null {
  const params = new URLSearchParams(search);
  const explicitTask = params.get('task')?.toLowerCase();
  if (explicitTask) return explicitTask;

  if (params.get('org')) return 'phishing';

  return storedTask;
}
